import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity'
import { Action, createReducer, on } from '@ngrx/store'

import * as ProjectorTemplatesActions from './projector-templates.actions'
import { ProjectorTemplatesEntity } from './projector-templates.models'
import * as ProjectorActions from 'libs/gb-dashboard/projector/data-access/src/lib/+state/projectors.actions'

export const PROJECTOR_TEMPLATES_FEATURE_KEY = 'projectorTemplates'

export interface ProjectorTemplatesState extends EntityState<ProjectorTemplatesEntity> {
  selectedId?: string
  loaded: boolean
  editCreateLoaded: boolean
  applyTemplateLoaded: boolean
}

export interface ProjectorTemplatesPartialState {
  readonly [PROJECTOR_TEMPLATES_FEATURE_KEY]: ProjectorTemplatesState
}

export const projectorTemplatesAdapter: EntityAdapter<ProjectorTemplatesEntity> =
  createEntityAdapter<ProjectorTemplatesEntity>({
    selectId: (model) => model.uuid,
  })

export const initialProjectorTemplatesState: ProjectorTemplatesState = projectorTemplatesAdapter.getInitialState({
  loaded: false,
  editCreateLoaded: true,
  applyTemplateLoaded: true,
})

const reducer = createReducer(
  initialProjectorTemplatesState,

  on(ProjectorTemplatesActions.loadProjectorTemplates, (state) => ({
    ...state,
    loaded: false,
  })),
  on(ProjectorTemplatesActions.loadProjectorTemplatesSuccess, (state, { templates }) =>
    projectorTemplatesAdapter.setAll(templates, {
      ...state,
      loaded: true,
    }),
  ),
  on(ProjectorActions.deleteProjectorTemplateSuccess, (state, action) =>
    projectorTemplatesAdapter.removeOne(action.uuid, {
      ...state,
    }),
  ),
  on(ProjectorTemplatesActions.loadProjectorTemplatesFailure, (state, { error }) => ({
    ...state,
  })),

  on(ProjectorTemplatesActions.loadProjectorTemplate, (state) => ({
    ...state,
  })),
  on(ProjectorTemplatesActions.loadProjectorTemplateSuccess, (state, { template }) =>
    projectorTemplatesAdapter.upsertOne(template, {
      ...state,
      selectedId: template.uuid,
    }),
  ),
  on(ProjectorTemplatesActions.selectProjectorTemplate, (state, { uuid }) => ({
    ...state,
    selectedId: uuid,
  })),
  on(ProjectorTemplatesActions.clearSelectedProjectorTemplate, (state) => ({
    ...state,
    selectedId: undefined,
  })),

  on(ProjectorTemplatesActions.updateProjectorTemplate, (state) => ({
    ...state,
    editCreateLoaded: false,
  })),
  on(ProjectorTemplatesActions.updateProjectorTemplateSuccess, (state, { update }) =>
    projectorTemplatesAdapter.updateOne(update, {
      ...state,
      editCreateLoaded: true,
    }),
  ),
  on(ProjectorTemplatesActions.updateProjectorTemplateFailure, (state, { error }) => ({
    ...state,
    editCreateLoaded: true,
  })),

  on(ProjectorTemplatesActions.saveProjectorAsTemplate, (state) => ({
    ...state,
    editCreateLoaded: false,
  })),
  on(ProjectorTemplatesActions.saveProjectorAsTemplateSuccess, (state, { template }) =>
    projectorTemplatesAdapter.upsertOne(template, {
      ...state,
      editCreateLoaded: true,
    }),
  ),
  on(ProjectorTemplatesActions.createProjectorTemplateSuccess, (state, { template }) =>
    projectorTemplatesAdapter.addOne(template, {
      ...state,
    }),
  ),
  on(ProjectorTemplatesActions.saveProjectorAsTemplateFailure, (state, { error }) => ({
    ...state,
    editCreateLoaded: true,
  })),

  on(ProjectorTemplatesActions.applySelectedTemplateToSelectedSlide, (state) => ({
    ...state,
    applyTemplateLoaded: false,
  })),
  on(ProjectorTemplatesActions.applySelectedTemplateToSelectedSlideSuccess, (state) => ({
    ...state,
    applyTemplateLoaded: true,
  })),
  on(ProjectorTemplatesActions.applySelectedTemplateToSelectedSlideFailure, (state) => ({
    ...state,
    applyTemplateLoaded: true,
  })),
)

export function projectorTemplatesReducer(state: ProjectorTemplatesState | undefined, action: Action) {
  return reducer(state, action)
}
